<template>
  <div class="expensereports">
    <div class="main-wrapper">
      <main-header></main-header>
      <sidebar></sidebar>
       <!-- Page Wrapper -->
       <div class="page-wrapper">
      
        <!-- Page Content -->
        <div class="content container-fluid">
        
        <expensereportheader />
          
        <expensereportfilter />
          
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <expensereportcontent />
              </div>
            </div>
          </div>
                </div>
        <!-- /Page Content -->
        
            </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
   
  export default {
    components: {
   
    },
    mounted() {


    },
    name: 'expensereports'
  }
</script>